module.exports = __webpack_public_path__ + "static/media/Politica_de_Privacidad_Enviamelo_090919.e752ae03.pdf";